import React from 'react';
import styled from 'styled-components';
import Title from '../../Components/Text/Title';
import SubTitle from '../../Components/Text/SubTitle';
import ScrollAnimation from 'react-animate-on-scroll';

import vision_icon1 from '../../Images/vision_icon1.svg';
import vision_icon2 from '../../Images/vision_icon2.svg';
import vision_icon3 from '../../Images/vision_icon3.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 180px;
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 1170px;
  position: relative;
  z-index: 10;
  justify-content: center;
  align-items: center;
  @media (max-width: 1210px) {
    width: 100%;
    padding: 0 20px;
  };
`
const ContentsContainer = styled.div`
  margin-top: 60px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  width: 100%;
`;
const Item = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  width: 380px;
  padding: 0 20px;
  @media (max-width: 1210px) {
    width: 50%;
  };
  @media (max-width: 680px) {
    width: 100%;
  };
  & > div:nth-child(1){
    position: relative;
    border-left: 1px solid #eee;
    &::after{
      position: absolute;
      content: '';
      top: 0;
      left: -1.5px;
      border: 1px solid #F78C1A;
      height: 18px;
    }
  }
  & > div:nth-child(2) {
    margin-left: 40px;
    & > div {
      height: 60px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    & > p:nth-child(2) {
      margin-top: 30px;
      font-weight: bold;
      font-size: 20px;
      line-height: 140%;
    }
    & > p:nth-child(3) {
      margin-top: 10px;
      font-weight: 100;
      font-size: 15px;
      line-height: 180%;
    }
  }
`
const Line = styled.div`
  width: 100%;
  margin-top: 280px;
  border: 1px solid #f8f8f8;
`

const VisionContainer = ({ language }) => {
  return (
    <Container>
      <SubContainer>
        <Title
          text={'Vision'}
        />
        <SubTitle
          style={{ marginTop: 40 }}
          title={
            language === 'Korean' ?
            '블록체인 게임 성장 인프라 및 유저 수익공유 시장 구축'
            :
            'Blockchain Game Growth Infrastructrue and User Revenue Sharing Market'
          }
          text={
            language === 'Korean' ?
            'GREX의 플랫폼 구조, 게임파이, 토큰 이코노미는 P2E 게임을 더 재미있게 만들고, 플레이어 중심의 생태계를 구축할 수 있도록 설계되었습니다. 우리가 만들고자 하는 비전은 모든 게임이 자금력이 아닌 재미 만으로 성장하고 유저와 수익을 공유할 수 있는 시장입니다.'
            :
            'GREX\'s platform, Game-Fi, Token Economy are designed to make P2E games more fun and build a player-centered ecosystem. The vision we create is a market where all games can grow only with fun and share profits with users, not with financial power.'
          }
        />
        <ContentsContainer>
          <Item>
            <div />
            <ScrollAnimation animateIn='fadeInUp'>
              <div>
                <img art='' src={vision_icon1} />
              </div>
              {
                language === 'Korean' ?
                  <>
                    <p>WEB3.0 Player Data</p>
                    <p>게인게임 리워드 API에서 수집되는 플레이어 데 이터는 분산화 스토리지에 백업되어 게임을 더 재미있게 만드는데 활용될 것입니다.</p>
                  </>
                  :
                  <>
                    <p>WEB3.0 Player Data</p>
                    <p>Player data collected from the In- Game Reward API will be backed up to Web 3.0 storage and make the game more fun.</p>
                  </>
              }
            </ScrollAnimation>
          </Item>
          <Item>
            <div />
            <ScrollAnimation animateIn='fadeInUp' duration="1.25">
              <div>
                <img art='' src={vision_icon2} />
              </div>
              {
                language === 'Korean' ?
                  <>
                    <p>Ingame Payment</p>
                    <p>VRX를 기반으로 게임 활성도에 따른 레이팅 알고리즘을 통해 게임화폐 간의 통합 및 교환, NFT 거래, 인게임 결제가 가능해집니다.</p>
                  </>
                  :
                  <>
                    <p>Ingame Payment</p>
                    <p>VRX-based rating algorithms enable integration and exchange between Game currencies, NFT transactions, and in-game payments</p>
                  </>
              }
            </ScrollAnimation>
          </Item>
          <Item>
            <div />
            <ScrollAnimation animateIn='fadeInUp' duration="1.5">
              <div>
                <img art='' src={vision_icon3} />
              </div>
              {
                language === 'Korean' ?
                  <>
                    <p>Game DAO & IGO</p>
                    <p>우리는 GRX를 이용하여 게임투자 DAO를 설 립할 것입니다. 향후 지렉스는 인디 게임을 위 한 IGO 플랫폼으로 진화할 것입니다.</p>
                  </>
                  :
                  <>
                    <p>Game DAO & IGO</p>
                    <p>We will establish a game investment DAO using GRX. In the future, GREX will evolve into an IGO platform for indie games.</p>
                  </>
              }
            </ScrollAnimation>
          </Item>
        </ContentsContainer>
        <Line />
      </SubContainer>
    </Container>
  )
}

export default VisionContainer;